// ACTIONS
import {
  CHANGE_RESULTS_VIEW,
  DETAIL_VIEW_OPEN,
  TOGGLE_MAP_SUMMARY_LIST,
} from '../actions/SearchResultsActions';
import { TABLE_VIEW } from '../../lib/config/appConstants';
const getInitialState = () => {
  return {
    showMapSummaryList: true,
    view: TABLE_VIEW,
    detailViewOpen: false,
  };
};

function SearchResultsReducer(state = getInitialState(), action) {
  switch (action.type) {
    case TOGGLE_MAP_SUMMARY_LIST:
      return {
        ...state,
        showMapSummaryList: !state.showMapSummaryList,
      };
    case CHANGE_RESULTS_VIEW:
      return {
        ...state,
        view: action.view,
        detailViewOpen: false,
      };
    case DETAIL_VIEW_OPEN:
      return {
        ...state,
        detailViewOpen: action.open,
      };
    default:
      return state;
  }
}

export default SearchResultsReducer;
